import t from './story12.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,
  regionName: t.regionName,

  prose: [
    // Run 1 — the open, no heading. Ends on the Midzi pull quote.
    [{ text: t.s1P1 }, { text: t.s1P2 }],
    // Run 2 — first themed section, up to the Unki figure.
    [{ title: t.s2Title, text: t.s2P1 }, { text: t.s2P2 }, { text: t.s2P3 }],
    // Run 3 — continues after the figure: the "source of deep tension" and Midzi
    // at length.
    [{ text: t.s3P1 }, { text: t.s3P2 }],
    // Run 4 — second themed section.
    [{ title: t.s4Title, text: t.s4P1 }, { text: t.s4P2 }, { text: t.s4P3 }],
    // Run 5 — third themed section, up to the resident's pull quote.
    [
      { title: t.s5Title, text: t.s5P1 },
      { text: t.s5P2 },
      { text: t.s5P3 },
      { text: t.s5P4 },
    ],
    // Run 6 — fourth themed section.
    [
      { title: t.s6Title, text: t.s6P1 },
      { text: t.s6P2 },
      { text: t.s6P3 },
      { text: t.s6P4 },
    ],
    // Run 7 — the close.
    [{ title: t.s7Title, text: t.s7P1 }, { text: t.s7P2 }, { text: t.s7P3 }],
  ],

  // PLACEHOLDER TEXT — the doc credits none of its three figures.
  captions: [
    // 01 — hero.
    [t.f1P1],
    // 02 — first `[IMAGE]` marker.
    [t.f2P1],
    // 03 — second `[IMAGE]` marker.
    [t.f3P1],
    // 04 — third `[IMAGE]` marker.
    [t.f4P1],
  ],

  quotes: [
    { text: t.q1, attribution: t.q1Attr },
    { text: t.q2, attribution: t.q2Attr },
  ],
} as const
